import { editShipmentApi } from "./editShipmentApi";

export const editShipmentSetData = async (
  lang,
  setMessageResponse,
  cookies,
  payload,
  setSuccessMessage,
  setBtnLoader,
  shipment_id
) => {

  const response = await editShipmentApi(payload, lang, cookies , shipment_id);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      type: "update",
      data: response.res.data.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
